<template>
  <div class="mentee-review-status-bar">
    <apexchart type="bar" :width="width" :height="250" :options="barChartOptions" :series="series" v-if="WidthFlag == 1" />
    <apexchart type="bar" :height="250" :options="barChartOptions" :series="series" v-else />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  props: {
    maxValue: {
      type: Number,
      default: 0,
    },
    tickAmount: {
      type: Number,
      default: 0,
    },
    barchartMentorReviewCategories: {
      type: Array,
      default() {
        return [];
      },
    },
    barchartMentorReviewSeries: {
      type: Array,
      default() {
        return [];
      },
    },
    barchartMentorReviewedSeries: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: {
    apexchart: VueApexCharts,
  },
  created() {
    var TotalWidth = parseInt(window.innerWidth / 2);
    var FinalWidth = parseInt(TotalWidth - 180);
    this.width = parseInt(this.barchartMentorReviewCategories.length * 40);
    if (this.width > FinalWidth) {
      this.WidthFlag = 1;
    }
  },
  data() {
    return {
      width: 0,
      WidthFlag: 0,
    }
  },
  computed: {
    series() {
      return [
        {
          name: 'Reviewed',
          data: this.barchartMentorReviewedSeries,
        },
        {
          name: 'Pending',
          data: this.barchartMentorReviewSeries,
        },
      ];
    },
    barChartOptions() {
      return {
        chart: {
          id: 'mentor_bar_chart',
          type: 'bar',
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        colors: ['#00ACEE', '#EE4200'],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 2,
            columnWidth: '15px',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: false,
        },
        xaxis: {
          categories: this.barchartMentorReviewCategories,
          labels: {
            style: {
              fontSize: '11px',
            },
          },
        },
        yaxis: {
          max: this.maxValue,
          tickAmount: this.tickAmount,
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          fontSize: '12px',
          markers: {
            width: 8,
            height: 8,
            radius: 0,
          },
        },
        grid: {
          strokeDashArray: 4,
          borderColor: '#e5e7eb',
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
        },
        fill: {
          opacity: 1
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            },
          },
          active: {
            filter: {
              type: 'none',
            },
          },
        },
        tooltip: {
          shared: true,
          intersect: false,
            custom: function({ series, dataPointIndex, w }) {
            const progress = series[0][dataPointIndex];
            const remaining = series[1][dataPointIndex];
            const label = w.globals.labels[dataPointIndex];

            return `
              <div style="padding:8px; font-size: 13px;">
                <div style=" font-size: 15px;"><strong>${label}</strong></div>
                <div style="background: #00ACEE;width: 10px; height: 10px;display: inline-block;border-radius: 0;"></div> Reviewed: ${progress}<br />
                <div style="background: #EE4200;width: 10px; height: 10px;display: inline-block;border-radius: 0;"></div> Pending: ${remaining}
              </div>
            `;
          }
        },
      }
    },

  },
};
</script>

<style scoped>
.mentee-review-status-bar {
  padding: 8px 12px 0;
}
.legend-swatch {
  width: 40px;
  height: 40px;
  margin-right: 8px;
  font-size: 11px;
}
.swatch-remain {
  background: #F59E0B;
}
</style>



// WEBPACK FOOTER //
// src/components/manager/mentee_review_status_barchart.vue